import GroupAlertFieldTypes from 'store/actionTypes/groupAlertField'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {}
}

const GroupAlertField = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case GroupAlertFieldTypes.GET_GROUP_ALERT_FIELDS_SUCCESS:
      return {
        ...state,
        list: payload?.items || []
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default GroupAlertField
